exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".b-form-group-content{color:#0d0d2a;font-weight:300}.action-item .form-group{margin-bottom:1.5rem}.action-item .b-form-group-content.read-only{white-space:pre-line}", ""]);

// exports
